import { Options, Vue } from 'vue-class-component';

import config from '@/config/config';
import PageBaseView from '@/pages/PageBaseView';
import * as ContactTypeService from '@/services/contact-type.service';
import { IContactType } from '@/domain/contact-type.model';

@Options({
  name: 'contact-type-view',
  props: {
    id: String,
  },
})
export default class ContactTypeView extends PageBaseView {
  public row: IContactType = {
    description: '',
    enabled: false,
  };

  public mounted(): void {
    this.url = 'contact-type';
    this.module = config.modules.contactType;

    ContactTypeService.get(this.id)
      .then((res: IContactType) => {
        if (res && res.id) {
          this.row = res;
        } else {
          this.errorMessage = 'Registro não encontrado.';
        }
      })
      .catch(() => {
        this.errorMessage = 'Registro não encontrado.';
      });
  }
}
